/**
 * Builds the URL to a fleet's public booking page (Webpage Settings), served at
 * `/book/{slug}`. Used to make the embed logo link back to that page when the
 * fleet has a webpage configured (i.e. a slug exists).
 *
 * @param slug         The fleet's webpage slug (from the business profile). When
 *                     falsy, returns undefined so the logo stays a plain image.
 * @param appBaseUrl   Absolute origin of the app hosting the booking page. REQUIRED
 *                     when the embed runs as a web component on a third-party site
 *                     (a relative path would resolve against the host). Omit inside
 *                     same-origin iframes, where the relative `/book/{slug}` works.
 * @param customDomain The fleet's verified custom domain (from the business profile).
 *                     The backend gates this value: it is non-null ONLY when verified,
 *                     so the frontend just checks presence — no verification here. When
 *                     a non-empty string is provided, the logo links to that domain's
 *                     root (`https://{customDomain}/`) instead of `/book/{slug}`.
 */
export function buildBookingHref(
  slug: string | null | undefined,
  appBaseUrl?: string,
  customDomain?: string | null,
): string | undefined {
  if (customDomain) return `https://${customDomain}/`;
  if (!slug) return undefined;
  const base = appBaseUrl ? appBaseUrl.replace(/\/+$/, "") : "";
  return `${base}/book/${slug}`;
}
